import { render } from "./ResetPassword.vue?vue&type=template&id=7057f6fc&scoped=true"
import script from "./ResetPassword.vue?vue&type=script&lang=js"
export * from "./ResetPassword.vue?vue&type=script&lang=js"

import "./ResetPassword.vue?vue&type=style&index=0&id=7057f6fc&lang=scss&scoped=true"
import "./ResetPassword.vue?vue&type=style&index=1&id=7057f6fc&lang=scss"

import exportComponent from "/Users/a/Desktop/app/boyuan_pc/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7057f6fc"]])

export default __exports__